import { useIntl } from 'react-intl';

export const useOfferHeader = () => {
  const { formatMessage } = useIntl();
  return formatMessage({ id: 'rewardsAndOffers' });
};
